"use client";

import * as React from "react";

interface PageHeaderProps {
    title: string;
    description: string;
    children?: React.ReactNode;
}

export function PageHeader({
    title,
    description,
    children,
}: PageHeaderProps) {
    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
            <div className="min-w-0">
                <h1 className="truncate text-xl font-semibold sm:text-2xl">{title}</h1>
                <p className="text-muted-foreground text-sm">{description}</p>
            </div>
            {children && (
                <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto sm:flex-nowrap">
                    {children}
                </div>
            )}
        </div>
    );
}
